import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormFeedback,
  FormInput,
  InputGroup,
  Row,
} from "shards-react";
import { changepassword } from "../../../backend/user";
import { UserContext } from "../../../backend/userContext";
import DismissAlert from "../../common/DismissAlert";

class UserAction extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
      oldpassword: "",
      password: "",
      password_check: null,
      nick: "",
      error: null,
      toggleAlert: false,
    };
    this.changePassword = this.changePassword.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(event) {
    event.preventDefault();
    event.target.reset();
    let params = {};
    if (
      this.context.user.privileges === "admin" &&
      this.props.activeUser.username !== this.context.user.username
    ) {
      params.username = this.props.activeUser.username;
    }
    changepassword(
      params,
      { oldPassword: this.state.oldpassword, newPassword: this.state.password },
      null,
      (error) => {
        this.setState({ error: error, toggleAlert: !this.state.toggleAlert });
      }
    );
  }

  errorband(error) {
    if (error === null) {
      return null;
    }
    let theme = "danger";
    let message = error.message;

    if (error === false) {
      theme = "success";
      message = "Contraseña cambiada correctamente";
    }
    return (
      <DismissAlert
        message={message}
        type={theme}
        toggle={this.state.toggleAlert}
        timeoutMs={5000}
      />
    );
  }

  changePassword(event) {
    let password = event.target.value;
    const strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
    );

    if (strongRegex.test(String(password))) {
      this.setState({ password: password, password_check: true });
    } else {
      this.setState({ password: password, password_check: false });
    }
  }

  render() {
    return (
      <Card small className=" ">
        <CardHeader className="">
          <h6 className="m-0 ">Cambiar contraseña</h6>
        </CardHeader>
        <CardBody className="">
          <Form onSubmit={this.handleSubmit}>
            <Container>
              <Col>
                <Row>
                  <InputGroup className="mb-2">
                    <FormInput
                      disabled={this.context.user.privileges === "admin"}
                      placeholder="Antigua Contraseña"
                      required={this.context.user.privileges === "admin"}
                      onChange={(event) => {
                        this.setState({ oldpassword: event.target.value });
                      }}
                      type={"password"}
                    />
                  </InputGroup>
                </Row>

                <Row>
                  <InputGroup className="mb-2">
                    <FormInput
                      placeholder="Contraseña nueva"
                      required
                      valid={this.state.password_check}
                      invalid={
                        this.state.password_check === null
                          ? null
                          : !this.state.password_check
                      }
                      onChange={this.changePassword}
                      type={"password"}
                    />
                    <FormFeedback>
                      La contraseña debe tener 8 caracteres, una mayuscula y un
                      numero
                    </FormFeedback>
                  </InputGroup>
                </Row>

                <Row className={"flex-column"}>
                  <div className={"mt-auto"} style={{ paddingTop: 11 }}>
                    <Button
                      className={"mt-auto"}
                      type="submit"
                      theme={"danger"}
                    >
                      Cambiar
                    </Button>
                  </div>
                </Row>
              </Col>
              <Row>
                <Col className={"col-12"}>
                  {this.errorband(this.state.error)}
                </Col>
              </Row>
            </Container>
          </Form>
        </CardBody>
      </Card>
    );
  }
}
export default UserAction;
